import React from 'react';

export default function Maintenance() {
  return (
    <div style={{ padding: '2rem', background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', minHeight: '600px' }}>
      <h1>Maintenance</h1>
      <p style={{ color: '#64748b' }}>Track repair status and manage asset condition.</p>
    </div>
  );
}
